import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1f955b86&scoped=true&"
import script from "./birthdayCareTask.ts?vue&type=script&lang=ts&"
export * from "./birthdayCareTask.ts?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=1f955b86&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f955b86",
  null
  
)

export default component.exports